<div class="modal-overlay" *ngIf="isOpen && !showCancellationReasonModal" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header Section -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Cancel the order?</h2>
        <button class="close-button" (click)="onClose()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Body Section -->
    <div class="modal-body">
      <div class="body-content">
        <p class="modal-message">
          Are you sure you want to cancel this order? This action is permanent and cannot be undone.
        </p>
      </div>
    </div>

    <!-- Footer Section -->
    <div class="modal-footer">
      <div class="footer-content">
        <!-- Desktop order: Yes, cancel first -->
        <button class="btn btn-secondary desktop-order" (click)="onConfirm()">
          <span>Yes, cancel</span>
        </button>
        <button class="btn btn-primary desktop-order" (click)="onClose()">
          <span>No, I don't want to cancel</span>
        </button>
        
        <!-- Mobile order: No, I don't want to cancel first -->
        <button class="btn btn-primary mobile-order" (click)="onClose()">
          <span>No, I don't want to cancel</span>
        </button>
        <button class="btn btn-secondary mobile-order" (click)="onConfirm()">
          <span>Yes, cancel</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Cancellation Reason Modal -->
<app-cancellation-reason-modal
  [item]="order"
  [isVisible]="showCancellationReasonModal"
  (close)="onCancellationReasonClose()"
  (submit)="onCancellationReasonConfirm($event)"
></app-cancellation-reason-modal>
